import { Button } from '@service-victoria/component-library/components/Button';
import Clock from '@service-victoria/component-library/components/Icons/Clock';
import Text from '@service-victoria/component-library/components/Text';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

const HeaderBoxPadding = 32;
const specialBlueColor = '#0052c2';

export const Wrapper = styled.div`
  @media ${device.isDesktop} {
    margin: 0 -${HeaderBoxPadding}px;
  }
`;

export const Line = styled.div`
  height: 2px;
  left: 0;
  position: absolute;
  background-color: ${colors.blueGrey10};

  @media ${device.isTablet} {
    width: 95vw;
  }

  @media ${device.isMobile} {
    width: 100vw;
  }
`;

export const DoubleLine = styled(Line)`
  height: 10px;
  margin-bottom: 10px;

  @media ${device.isDesktop} {
    width: 1024px;
  }
`;

export const TimerBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: ${HeaderBoxPadding}px;

  @media ${device.isMobile}, ${device.isTablet} {
    padding: 27px;
  }
`;

export const Description = styled(Text.Heading.H2)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${HeaderBoxPadding}px;
  padding-right: 10px;
  font-family: VIC;
  font-size: 24px;
  color: ${colors.blueGrey};

  @media ${device.isDesktop} {
    max-width: 500px;
  }

  @media ${device.isMobile}, ${device.isTablet} {
    padding: 27px;
    margin-bottom: 0;
  }
`;

export const Timer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 92px;
  color: ${colors.blueGrey};
  padding-top: 2px;
`;

export const Header = styled.div`
  @media ${device.isDesktop} {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;

    ${Line} {
      height: 128px;
      position: relative;
      width: 2px;
    }
  }
`;

export const Icon = styled(Clock)`
  fill: ${colors.blueGrey25};
  height: 42px;
  margin-right: 24px;
`;

export const TextHead = styled.div`
  height: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;

  span {
    font-size: 34px;
  }
`;

export const Main = styled.main`
  padding-top: 10px;

  @media ${device.isTablet}, ${device.isMobile} {
    padding-top: 24px;
  }
`;

export const GetStartedButton = styled(Button).attrs({ type: 'button' })`
  box-sizing: border-box;
  margin: 0 50px 40px auto;

  @media ${device.isMobile} {
    margin: 40px 0;
  }
`;

export const Footer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: #3b4a60;
  padding: 48px;

  @media ${device.isMobile} {
    flex-direction: column;
    padding: 30px;
  }
`;

export const VicLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-top: 8px;
  }
`;

export const Aside = styled.aside`
  @media ${device.isMobile} {
    margin: 20px;
  }
`;

export const SignpostWrapper = styled.div`
  padding: 0 ${HeaderBoxPadding}px ${HeaderBoxPadding}px;
  min-height: 260px;
  h1 {
    font-weight: bold;
    color: ${specialBlueColor};
    margin-bottom: 46px;
  }

  p {
    color: ${specialBlueColor};
    margin-bottom: 30px;
  }
`;
